import {NucleotideType} from 'biojs/BioConstants';
import {CustomServerResolutionResult} from 'notebook/tables/string-resolution/StringResolutionConstants';
import * as net from 'util/Net';

export function validateHelm(
  nucleotideType: NucleotideType,
  helmStrings: Array<string>
): Promise<{serverResolutionResults: Array<CustomServerResolutionResult>}> {
  return net.postJSONPromise({
    url: '/1/api/eln:bulk-validate-helm',
    data: {nucleotideType, helmStrings},
  });
}

export function validateIdt(
  nucleotideType: NucleotideType,
  idtStrings: Array<string>
): Promise<{serverResolutionResults: Array<CustomServerResolutionResult>}> {
  return net.postJSONPromise({
    url: '/1/api/eln:bulk-validate-idt',
    data: {nucleotideType, idtStrings},
  });
}

export function validateCustomSyntax(
  nucleotideType: NucleotideType,
  customSyntaxName: string,
  customSyntaxStrings: Array<string>
): Promise<{serverResolutionResults: Array<CustomServerResolutionResult>}> {
  return net.postJSONPromise({
    url: '/1/api/eln:bulk-validate-custom-syntax',
    data: {nucleotideType, customSyntaxStrings, customSyntaxName},
  });
}
